import React from 'react'
import { PrimaryButtonView } from 'components'

export default ({ isCheckingEmail }) => (
  <PrimaryButtonView
    disabled={isCheckingEmail}
    label={isCheckingEmail ? 'CHECKING...' : 'NEXT'}
  />
)
